var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"character-input-warning warning"},[_c('div',{staticClass:"character-input-warning__message white--text",attrs:{"id":_vm.instructionId}},[_vm._v("\n    It seems some of the characters in your "+_vm._s(_vm.fieldName)+" were not rendered\n    correctly. Please check and make any changes before continuing.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }